<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="privacy-protection">
      <Title jpn="Privacy policy" />
      <div class="scroll-container">
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Hatchi Co., Ltd. (hereinafter referred to as ''the Company'') requires users to provide a minimum amount of personal information so that they can use the site with peace of mind.</span>
            <span class="text">In addition, we take the utmost care to protect the personal information provided to us.</span>
            <span class="text">Our company's approach to personal information protection is as follows.</span>
            <br>
            <span class="text">(1)The Company will use the information of individuals, organizations, and corporations registered by members only to develop and provide cutting-edge functions and services, and will pay close attention to the protection of members' personal information.</span>
            <span class="text">(2) This privacy policy applies only to the services provided by our company.</span>
            <span class="text">(3) Except as specified in these Terms, the information will not be used for any other purpose.</span>
            <span class="text">(4) Except as specified in these Terms, we will not disclose your information to third parties.</span>
            <span class="text">(5) We will regularly conduct appropriate management using other methods stipulated in these Terms.</span>
            <span class="text">(6) Our company may change the privacy policy without the user's permission.</span>
            <span class="text">When our company makes changes to the content of personal information acquired, methods of use, changes to the content of disclosure, etc., we will notify you by posting a notice on our website and reflecting it in this privacy policy so that users can be aware of the content.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Section 1. Scope of application of our privacy policy</span>
            <span class="text">(1) Our privacy policy applies when members use our services.</span>
            <span class="text">(2)Personal information collected when members use our services will be managed in accordance with our company's policy on personal information protection.</span>
            <span class="text">(3) Our policy on personal information protection applies only to services provided directly by our company, and does not apply to services provided by other organizations or companies.</span>
            <span class="text">(4)Use of our services is at the user's own risk.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Section 2. Collection and use of our personal information</span>
            <span class="text">(1) In order to develop and provide cutting-edge functions and services to our members, we require some personal information from our users.</span>
            <span class="text">(2) Users are responsible for managing their registered email address and password.</span>
            <span class="text">1. Change your password regularly, and we do not recommend using names, dates of birth, phone numbers, etc. that are easy for others to guess.</span>
            <span class="text">2. Please do not disclose, lend, or transfer your personal information, even if it is to an acquaintance or friend.</span>
            <span class="text">(3) Collected personal information will be used only to the extent necessary to provide our services, and will not be provided to any third party except in the following cases.</span>
            <span class="text">1. When a credit card company makes an inquiry to investigate fraudulent card use.</span>
            <span class="text">2. When sending e-mail etc. for advertising to members.</span>
            <span class="text">3. When entrusting the handling of personal information to a subcontractor with which we have concluded a confidentiality agreement regarding personal information to the extent necessary to achieve the purpose of use specified to the user.</span>
            <span class="text">4. When it is deemed necessary to protect the rights or property of other members, third parties, or the Company, in the event that a member's actions at the Company violate the Company's policies, announcements, or the Company's Terms of Use.</span>
            <span class="text">5. When disclosure of personal information is requested pursuant to the provisions of other laws such as orders from a court or administrative agency, or when there is a need for criminal investigation, elimination or prevention of infringement of rights against third parties, or other similar necessity.</span>
            <span class="text">(4) Members shall agree in advance to the Company's use of personal information in the manner specified above, and shall not raise any objections.</span>
            <span class="text">(5) Additionally, we may share members' personal information with our business partners in the following cases:</span>
            <span class="text">1. When there is a business reason, such as special services for members. In this case, we will ask for the member's consent before providing the information, and we will not provide the information without their consent.</span>
            <span class="text">2. When creating statistical materials, conducting market research, or conducting data analysis. In this case, we will only provide information that has been processed so that specific individuals cannot be identified.</span>
          </div>
        </ShadowBoxTitleDescription>
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ShadowBoxTitleDescription from '@/components/molecules/ShadowBoxTitleDescription.vue';
import Title from '@/components/molecules/Title02.vue';
import t from '@/plugins/i18n';

export default {
  name: 'TermsOfService',
  mixins: [t],

  components: {
    BaseTemplate,
    ShadowBoxTitleDescription,
    Title,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),
  },

  created() {
    this.$store.dispatch('user/setCurrentUser', { token: 'yugi' });
  },
};
</script>

<style lang="scss" scoped>
.privacy-protection{
  width: 100%;
  max-width: 1200px;
  min-height: 100%;
  padding: 30px 20px 0;
  margin: 0 auto;
  .privacy-protection-title{
    display: flex;
    justify-content: center;
    .text{
      height: 35px;
      font-family: $notoSerif;
      font-size: 24px;
      font-weight: 700;
    }
  }
  .scroll-container{
    width: 100%;
    margin-top: 30px;
    padding-bottom: 50px;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    .shadow-box-title-description{
      width: 100%;
      .text-container{
        display: flex;
        flex-direction: column;
        padding: 5px 5px 0 5px;
        .text{
          font-family: $notoSans;
          font-size: 13px;
          line-height: 1.5;
          letter-spacing: 0.03em;
          a {
            color: $white!important;
          }
          &.margin-top{
            margin-top: 10px;
          }
          &.one-line-space-top{
            margin-top: 1em;
          }
          &.indent{
            padding-left: 2.6em;
            text-indent: -1.6em;
          }
        }
      }
      & + .shadow-box-title-description{
        margin-top: 40px;
      }
    }
  }
}
</style>
